<div class="container">
  <div class="col-md-12">
    <br>
    <div class="d-flex justify-content-start">
      <p-selectButton [options]="screentypes" [(ngModel)]="selectedscreentype" (onChange)="setScreenType($event)"></p-selectButton>
    </div>
    <hr>
    <button *ngIf="!editmode" class="btn" (click)="setEditMode()">Ändra</button>
    <button *ngIf="editmode" class="btn mx-1" (click)="saveInfoText()" [disabled]="dirty">Spara</button>
    <button *ngIf="editmode" class="btn  mx-1" (click)="editmode=false">Avbryt</button>
    <br>
    <br>
    <div *ngIf="!editmode" [innerHTML]="safeText"></div>
    <p-editor *ngIf="editmode" [(ngModel)]="text" [style]="{'height':'400px'}"></p-editor>
 
  </div> 
</div>